import { useEffect, useState } from 'react'
import axios from 'axios';
import { useNavigate } from 'react-router-dom'
import { toast, } from 'react-toastify';
import { listContact, deleteContact, contactStatus } from '../../../Context/api';
import { statusCodes, commonMessage } from '../../../Constants/generalConfig';


const UseContact = () => {
    const [contactsList, setContactsList] = useState([])
    const userData = JSON.parse(localStorage.getItem('userData'));
    const [spinner, setSpinner] = useState(false)
    const navigate = useNavigate()
    const [count, setCount] = useState('')
    const [page, setPage] = useState(1)
    const PER_PAGE = 10
    const [deleteShow, setDeleteShow] = useState({ open: false, data: '' })


    useEffect(() => {
        list()
    }, [page])

    const list = () => {
        setSpinner(true)
        const payload = {
            providerId: userData?.userId,
            type: "SERVICE_PROVIDER",
            count: PER_PAGE,
            page: page,
        }
        axios.post(listContact(), {...payload}, { headers: { Authorization: `Bearer ${userData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setContactsList(resp.data)
                setCount(resp?.data?.totalCount)
                setSpinner(false)
            }
            else {
                setContactsList([])
                setSpinner(false)
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    const contactDelete = () => {
        setSpinner(true)
        axios.post(deleteContact(), { id: deleteShow?.data?._id }, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                list()
                setSpinner(false)
                setDeleteShow({ open: false, data: '' })
            }
            else {
                setSpinner(false)
                toast.error(resp.data.message)
            }
        })
    }
    const statusChange = (item) => {
        setSpinner(true)
        axios.post(contactStatus(), { id: item._id, isActive: !item.isActive }, { headers: { Authorization: `Bearer ${userData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                list()
                setSpinner(false)
            }
            else {
                toast.error(resp.data.message)
                setSpinner(false)
            }
        })
    }
    return {
        contactDelete,
        navigate,
        setPage,
        setDeleteShow,
        statusChange,
        contactsList,
        PER_PAGE,
        deleteShow,
        page,
        count,
        spinner,
    }
}

export default UseContact